/** Prices from refurbished index/detail endpoints are pre-formatted by the API. */
export const getRefurbishedPricing = (
    discountedPrice: string,
    originalPrice: string,
): { current: string; original: string | undefined } => ({
    current: discountedPrice,
    original: originalPrice !== discountedPrice ? originalPrice : undefined,
});
